import { type FC } from 'react';
import { Button } from '@selfinspectionorg/ui-kit';
import ChevronLeftIcon from './assets/chevron-left.svg?react';
import styles from './BackButton.module.scss';

interface Props {
  onClick: () => void;
  testId?: string;
}

export const BackButton: FC<Props> = ({ onClick, testId }) => {
  return (
    <div className={styles.wrapper}>
      <Button.Ghost onClick={onClick} className={styles.button} size="small" data-testid={testId}>
        <ChevronLeftIcon />
        <div>Back</div>
      </Button.Ghost>
    </div>
  );
};
